// External
import React from "react";
import classNames from "classnames";
import { fontStyles } from "@toddle-edu/ds-theme";

// Relative
import { useI18n } from "Hooks";
import { useCallbackRef } from "Utils";
import UIBaseContentEditable from "UIComponents/UIBaseContentEditable";

// Internal
import classes from "./AIPanelInputBox.scss";

// Styles
const styles = {
  uiContentEditable: {
    fontSize: "1.4rem",
    lineHeight: "2rem",
    padding: "12px 16px",
    maxHeight: "150px",
    minHeight: "40px",
    overflowY: "auto",
    ...fontStyles.medium,
  },
};

const AIPanelInputBox = props => {
  const { t } = useI18n();
  const { isDisabled, inputMessage, setInputMessage } = props;
  const [contentEditableRef, setContentEditableRef] = useCallbackRef(null);

  const inputBoxClasses = classNames(classes.inputBox, {
    [classes.disabled]: isDisabled,
  });

  return (
    <div className={inputBoxClasses}>
      <UIBaseContentEditable
        minRows={1}
        maxRows={5}
        id="ai-input-box"
        onKeyDown={() => {}}
        disabled={isDisabled}
        shouldParseInPlainText={false}
        style={styles.uiContentEditable}
        value={inputMessage?.value || ""}
        updateInputRef={setContentEditableRef}
        placeholder={t("common:ask_toddle_ai")}
        updateInputField={value => {
          setInputMessage({ ...inputMessage, value });
        }}
      />
    </div>
  );
};

export default AIPanelInputBox;
